import { createFileRoute } from "@tanstack/react-router";
import DepressionTreatmentCoralSpringsHub from "@/pages/DepressionTreatmentCoralSpringsHub";
import {
  SITE_URL,
  buildBreadcrumbList,
  buildMedicalWebPage,
} from "@/components/schemaConstants";

const PAGE_URL = `${SITE_URL}/depression-treatment-coral-springs`;
const BREADCRUMB_ID = `${PAGE_URL}#breadcrumb`;

export const Route = createFileRoute("/depression-treatment-coral-springs")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Depression Treatment in Coral Springs, FL | TMS, SPRAVATO®, Therapy & Medication Management",
        },
        {
          name: "description",
          content:
            "Outpatient depression treatment in Coral Springs for young adults, adults and seniors: TMS, SAINT®, SPRAVATO®, therapy and medication management. Medicare & VA in-network.",
        },
        {
          property: "og:title",
          content:
            "Depression Treatment in Coral Springs, FL | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Outpatient depression treatment in Coral Springs for young adults, adults and seniors. TMS, SAINT®, SPRAVATO®, therapy and medication management. Medicare & VA in-network.",
        },
        { property: "og:url", content: PAGE_URL },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: PAGE_URL }],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            buildMedicalWebPage({
              name: "Depression Treatment in Coral Springs, Florida",
              description:
                "Outpatient depression treatment in Coral Springs for young adults, adults and seniors: TMS, SAINT®, SPRAVATO®, therapy and medication management. Medicare & VA in-network.",
              url: PAGE_URL,
              id: `${PAGE_URL}#webpage`,
              breadcrumbId: BREADCRUMB_ID,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            buildBreadcrumbList(
              [
                { name: "Home", href: "/" },
                {
                  name: "Depression Treatment",
                  href: "/depression-treatment-coral-springs",
                },
              ],
              BREADCRUMB_ID,
            ),
          ),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionTreatmentCoralSpringsHub />;
}
